import { Card, CardSuit } from "../card/Card";
import { LoaderFileKeys } from "../constant/AppConstants";
import { IconButton } from "../../ui/IconButton";
import { LabelButton } from "../../ui/LabelButton";
import { TablePopupWindow } from "./TablePopupWindow";
import { AppSettings } from "../managers/AppSettings";
import { RectSize } from "../../utils/RectSize";
import { TextureData } from "../../types/types";
import { IInteractive } from "../../interfaces/IInteractive";
import { ButtonBase, ButtonEvents } from "../../ui/ButtonBase";
import { AppLocalization, LanguageId } from "../localization/AppLocalization";
import { GetCardSuitIconTextureStatesData, TrumpIconType } from "../utils/GetCardSuitIconTextureData";
import { AppAudioPlayer, SoundEffectKeys } from "../../audio/AppAudioPlayer";
import { LayoutDataManager } from "../managers/LayoutDataManager";


/**
 * @see TrumpSuit minus UNDEFINED plus PASS
 */
 export enum PopupBiddingChoiceType {
    SPADES,
    CLUBS,
    DIAMONDS,
    HEARTS,
    NOTRUMPS,
    ALLTRUMPS,
    /**
     * Coinche|Contree only
     */
    CONTRA_RECONTRA,
    /**
     * Take suit and Choose suit popups (both)
     */
    PASS,
    /**
     * Take suit only
     */
    ACCEPT,
}

export class PopupBiddingTakeSuit extends TablePopupWindow
{
    public nsContentBg: Phaser.GameObjects.NineSlice;
    public nsContentBgExtrusion: number = 25; // extrude to cover for outer drop shadow size
    public nsHeaderBg: Phaser.GameObjects.NineSlice;
    public txtHeader: Phaser.GameObjects.Text;
    public nsCardBg: Phaser.GameObjects.NineSlice;
    public card: Phaser.GameObjects.Image;
    public btnSuit: IconButton;
    public btnPass: LabelButton;

    protected cardTextureData: TextureData;
    /**
     * Auto-enable on Show and auto-disable on Hide all interactives eg buttons
     */
    protected interactives: IInteractive[];


    public override Init(): void
    {
        // >> create screenOverlayHitArea
        super.Init();

        this.interactives = [];
    }

    public override Build(): void
    {
        // console.log("PopupBiddingSub::Build");

        const btnScale: number = 0.8;
        const btnIconScale: number = 1.0;

        const bgSize: RectSize = new RectSize(520, 740);
        const nsContentBgBorderSize = 55;
        this.nsContentBg = this.scene.make.nineslice({
            key: LoaderFileKeys.ui,
            frame: "rect-black-w72-r24-A80-ds.png",
            leftWidth: nsContentBgBorderSize, 
            rightWidth: nsContentBgBorderSize, 
            topHeight: nsContentBgBorderSize, 
            bottomHeight: nsContentBgBorderSize,
            // alpha: 0.9, // tex already has an alpha?
        });
        this.nsContentBg.setSize(bgSize.width + 2 * this.nsContentBgExtrusion, bgSize.height + 2 * this.nsContentBgExtrusion);
        this.add(this.nsContentBg);

        // header bg
        const nsHeaderBgBorderSize = 46;
        this.nsHeaderBg = this.scene.make.nineslice({
            key: LoaderFileKeys.ui,
            frame: "bidPopup-header-bg.png",
            leftWidth: nsHeaderBgBorderSize, 
            rightWidth: nsHeaderBgBorderSize,
            y: -bgSize.height * 0.5,
        });
        this.add(this.nsHeaderBg);

        // header title
        this.txtHeader = this.scene.make.text({
            y: this.nsHeaderBg.y,
            style:{
                color: AppSettings.colors.whiteString,
                fontSize: "30px",
                align: "center",
                fontFamily: AppSettings.fontFamilies.MontserratBold,
                metrics: AppSettings.metrics.montserratBold30,
            }
        });
        this.txtHeader.setOrigin(0.5);
        this.add(this.txtHeader);
        
        const nsCardBgBorderSize = 30;
        this.nsCardBg = this.scene.make.nineslice({
            key: LoaderFileKeys.ui,
            frame: "rect-nofill-str2px_white-w72-r24.png",
            leftWidth: nsCardBgBorderSize, 
            rightWidth: nsCardBgBorderSize, 
            topHeight: nsCardBgBorderSize, 
            bottomHeight: nsCardBgBorderSize,
            alpha: 0.8,
        });
        this.nsCardBg.y = -120;
        this.nsCardBg.setDisplaySize(360, 400);
        this.add(this.nsCardBg);

        this.card = this.scene.make.image({});
        this.card.setPosition(0, this.nsCardBg.y);
        this.card.scale = 0.8;
        this.add(this.card);

        this.btnSuit = new IconButton(this.scene, 0, 165);
        this.btnSuit.setData({choiceType:PopupBiddingChoiceType.ACCEPT});
        this.btnSuit.InitBase({
            out:{texture:LoaderFileKeys.ui, frame:"btn-oval3-bg-out.png"},
        });
        this.btnSuit.InitIcon(GetCardSuitIconTextureStatesData(CardSuit.SPADES, TrumpIconType.POPUP_CHOOSE_OR_TAKE_SUIT), null, btnIconScale);
        this.btnSuit.PostInit(20); // sets interactive
        this.btnSuit.setScale(btnScale);
        this.interactives.push(this.btnSuit);
        this.add(this.btnSuit);

        this.btnPass = new LabelButton(this.scene, 0, 280);
        this.btnPass.setData({choiceType:PopupBiddingChoiceType.PASS});
        this.btnPass.InitBase({
            out:{texture:LoaderFileKeys.ui, frame:"btn-oval3-bg-out.png"},
            disabled:{texture:LoaderFileKeys.ui, frame:"btn-oval3-bg-disabled.png"},
        });
        this.btnPass.InitLabel(
            {
                out: {
                    color: "#000",
                    fontSize: "60px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold60,
                },
                disabled: {
                    color: "#999",
                    fontSize: "60px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold60,
                }
            }
        );
        // this.btnPass.label.text = AppLocalization.GetSharedData().table.declarations.pass;
        this.btnPass.label.setOrigin(0.5);
        this.btnPass.PostInit(20);
        this.btnPass.setScale(btnScale);
        this.interactives.push(this.btnPass);
        this.add(this.btnPass);
    }
    
    public override Show(animated: boolean = true): void
    {
        super.Show(animated);
        this.SetInteractive(true);
    }

    public override Hide(animated: boolean = true): void
    {
        super.Hide(animated);
        this.SetInteractive(false);
    }

    /**
     * SetInteractive on all children
     */
    public SetInteractive(value: boolean): void
    {
        let setEnabled: boolean = false;
        for (let i = 0; i < this.interactives.length; i++) {
            const btn = this.interactives[i];
            const btnChoiceIndex: PopupBiddingChoiceType = (btn as ButtonBase).getData("choiceType");
            if (this.inputData != undefined && this.inputData.disabledChoices != undefined) {
                // if button should be disabled
                // console.log(PopupBiddingChoiceType[btnChoiceIndex], this.inputData.disabledChoices.indexOf(btnChoiceIndex));
                if (this.inputData.disabledChoices.indexOf(btnChoiceIndex) != -1) {
                    setEnabled = false;
                }
                else {
                    setEnabled = value;
                }
            }
            else {
                setEnabled = value;
            }

            // apply interactivity and listeners
            btn.SetInteractive(setEnabled);
            if (setEnabled) {
                (btn as ButtonBase).on(ButtonEvents.CLICK, this.OnButtonClicked, {root:this, target:btn});
            }
            else {
                (btn as ButtonBase).off(ButtonEvents.CLICK, this.OnButtonClicked);
            }
        }
    }

    public override SetData(inputData:any): void
    {
        super.SetData(inputData);
        const topCard: Card = this.inputData.topCard;
        this.card.setTexture(topCard.view.texture.key, topCard.view.frame.name);
        this.btnSuit.SetIconTextureData(GetCardSuitIconTextureStatesData(topCard.suit, TrumpIconType.POPUP_CHOOSE_OR_TAKE_SUIT));
    }

    public OnButtonClicked(): void
    {
        const root: PopupBiddingTakeSuit = this["root"] as PopupBiddingTakeSuit;
        const btn: ButtonBase = this["target"] as ButtonBase;
        const choiceType: number = btn.getData("choiceType");

        // button click
        AppAudioPlayer.PlaySfx(SoundEffectKeys.click5);
        
        root.Hide();
        root.inputData.onComplete(root.inputData.taskType, {choiceType:choiceType});
    }

    /**
     * cancel base functionality
     * - PopupWindow::screenOverlay will NOT be drawn
     */
    public override OnResize(windowRect: RectSize): void {}

    public UpdateViewFromLocalizationChange(languageId: LanguageId): void
    {
        this.txtHeader.text = AppLocalization.GetSharedData(languageId).table.bidding.popup.headerLabel;
        this.btnPass.label.text = AppLocalization.GetSharedData(languageId).table.declarations.pass;
        
        // stretch header bg to label width + padding
        this.nsHeaderBg.width = this.txtHeader.width + 2 * LayoutDataManager.GetSharedData().table.bidding.popup.header.padding.horizontal;
    }
}